<template>
  <div class="wrapper home-page">
    <div class="page-header clear-filter">
      <div>
        <parallax
            class="page-header-image"
            :style="{ backgroundImage: `url(${bgImage})` }"
        />
      </div>
      <div class="rellax-text-container rellax-text">
        <h1
            class="h1-seo font-goodtimes"
            data-rellax-speed="-2"
        >
          123db
        </h1>
      </div>
      <h3
          class="h3-description rellax-text"
          data-rellax-speed="-1"
      >
        das Schweizer Taschenmesser unter den ERP Systemen
        <br />
        &nbsp;
        <br />
        entspannt alle Daten im Griff - und das auch im KI Zeitalter
      </h3>
    </div>

    <features-section />
  </div>
</template>

<script>
  import FeaturesSection from './sections/Features'

  export default {
    name: 'Home',
    bodyClass: 'home-page',
    components: {
      FeaturesSection
    },
    data() {
      return {
        bgImage: require('@/assets/img/bg.jpg')
      }
    }
  }
</script>
